import Products from "../Components/Products";
import './Index.css';
function Index() {
  return (
    <div className="Index">
      <h2>All Products</h2>
      <Products />
    </div>
  );
}

export default Index;